import React from "react";
import PropTypes from "prop-types";

const FormWrapper = ({ children }) => {
  return <div className="form-row form-custom form-wrap">{children}</div>;
};

FormWrapper.propTypes = {
  children: PropTypes.node,
};

export default FormWrapper;
